import { render, staticRenderFns } from "./inline.vue?vue&type=template&id=0280b5d7&scoped=true"
import script from "./inline.vue?vue&type=script&lang=js"
export * from "./inline.vue?vue&type=script&lang=js"
import style0 from "./inline.vue?vue&type=style&index=0&id=0280b5d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0280b5d7",
  null
  
)

export default component.exports